export const truncate = (str = "", limit = 10) => {
  if (str?.length > limit) return str.substring(0, limit) + "...";

  if (!str) return "--";

  return str;
};

export const capitalizeFirstLetter = (string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
  return "";
};

// if you want to replace keys with values pass key and value arguments as array,
// otherwise just pass single string for each.
export const replaceKeyWithValue = (text = "", key = "", value) => {
  const splittedArray = text.split("#");

  if (Array.isArray(key) && Array.isArray(value)) {
    // TODO: need to implementation
    return splittedArray.join("");
  }

  splittedArray[1] = value;

  return splittedArray;
};

export const toEnDigit = (s) => {
  return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (a) {
    return a.charCodeAt(0) & 0xf;
  });
};
